import moment from 'moment-timezone';
// import moment from 'moment';
// import moment from 'moment-timezone/moment-timezone-utils';

 class TimingSynchronizer {
    protected static instance = new TimingSynchronizer();

    private constructor() {
        moment.locale('ru');
    }

    private offset = 0;

    public setDelta(serverTime: string) {
        this.offset = moment(serverTime).diff(new Date());
        this.applyOffset();
    }

    public setTimeZone(zoneOffset: number) {
        this.offset = 0;
        // Нормально работает для zoneOffset от 1 до 12:
        moment.tz.setDefault(`Etc/GMT-${zoneOffset}`);
    }

    private applyOffset() {
        moment.now = this.calcOffset.bind(this);
    }

    private calcOffset() {
        return +new Date() + this.offset;
    }

    public static getInstance(): TimingSynchronizer {
        return TimingSynchronizer.instance;
    }
}

export const timingSynchronizer = TimingSynchronizer.getInstance();
